import styled from '@emotion/styled'

import { Color } from '../../../../enums/color'
import { Themable } from '../../../../types/themable'
import { TableRow } from '../TableRow'

export const TableEmptyView = styled(TableRow)`
  cursor: unset;

  &,
  &:hover {
    background-color: ${Color.White};
  }
`

type TableEmptyViewContentProps = Themable

export const TableEmptyViewContent = styled.div<TableEmptyViewContentProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${({ theme }) => theme.ds.colors.base.textPrimary};
  text-align: center;
  white-space: pre-wrap;
`
